import { Box } from '@mui/material';
import { TextFieldElement } from 'react-hook-form-mui';
import { useIntl } from 'react-intl';
import { DescriptionFooterSelector } from './DescriptionFooterSelector';
import { EmojiAdornment } from './EmojiAdornment';
import { EmojiSelectionRange } from './EmojiPickerButton';
import { insertTextAtSelection } from './insert-text-at-selection';
import { useFragmentForm } from './useFragmentForm';

/** Title, description, and footer selector fields for the create-fragment form. */
export function CreateFragmentBasicFields() {
  const { $t } = useIntl();
  const { getValues, setValue } = useFragmentForm();

  /** Inserts an emoji at the caret (or replaces the current selection) in a string field. */
  function insertEmoji(
    fieldName: 'title' | 'description',
    emoji: string,
    selection: EmojiSelectionRange,
  ) {
    const current = getValues(fieldName) || '';
    setValue(fieldName, insertTextAtSelection(current, emoji, selection.start, selection.end));
  }

  return (
    <>
      <TextFieldElement
        name="title"
        label={$t({ id: 'fragments.props.title', defaultMessage: 'Título' })}
        placeholder={$t({
          id: 'fragments.form.title.placeholder',
          defaultMessage: 'Entrevista con Messi',
        })}
        fullWidth
        required
        multiline
        minRows={2}
        maxRows={3}
        autoFocus
        InputProps={{
          endAdornment: (
            <EmojiAdornment
              onSelect={(emoji, selection) => insertEmoji('title', emoji, selection)}
              position="left"
            />
          ),
        }}
      />

      <TextFieldElement
        name="description"
        label={$t({ id: 'fragments.props.description', defaultMessage: 'Descripción' })}
        placeholder={$t({
          id: 'fragments.form.description.placeholder',
          defaultMessage: 'Grabada en el estadio durante el Mundial',
        })}
        multiline
        minRows={3}
        maxRows={8}
        fullWidth
        InputProps={{
          endAdornment: (
            <EmojiAdornment
              onSelect={(emoji, selection) => insertEmoji('description', emoji, selection)}
              position="left"
            />
          ),
        }}
      />

      <Box mt={-1.25}>
        <DescriptionFooterSelector />
      </Box>
    </>
  );
}
